import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"d-inline-flex",staticStyle:{"width":"200px"}},[_c('b',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.title))])]),_c(VRangeSlider,{staticClass:"align-center",attrs:{"max":_vm.max,"min":_vm.min,"hide-details":"","tick-size":"4","step":_vm.step,"tick-labels":_vm.tickLabels,"value":_vm.data},on:{"change":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }